import React, { useState } from 'react'
import { Box, Fade, Modal } from "@mui/material";
import { style, } from "../helpers/style";
import Backdrop from "@mui/material/Backdrop";
import { lua, global, } from "../translate";
import Api from '../Api';
import {useLocation, useNavigate} from "react-router-dom";

export default function LuaCrm({open,setOpen}) {
    const navigate = useNavigate()
    const handleSubmit = async () => {
        try{
            await Api.createLua(code)
            navigate("/crm_integration/lua")
        }catch(e){

        }
    }
    const [code, setCode] = useState('')
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => {
                setOpen(false)
            }}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>

                    <form onSubmit={handleSubmit} className="d-flex flex-column justify-content-between">
                        <div className="d-flex justify-content-between">
                            <h3>LuaCRM</h3>
                            <span style={{ cursor: 'pointer' }} onClick={() => {
                                setOpen('')
                                navigate('/crm_integration')
                            }}>
                                x
                            </span>
                        </div>
                        <label className="count" style={{ width: '93%', marginBottom: 30 }}>
                            <p style={{ marginBottom: 30 }}>{lua.p[+localStorage.getItem('atsLang') || 1]}</p>
                            <input placeholder="jZJFCfM084pO6*******" value={code} onChange={(ev) => setCode(ev.target.value)} />
                        </label>
                       
                    </form>
                    <div id="transition-modal-description sip_content" className="test_mode">
                        
                        <div className="d-flex justify-content-center">
                            <button style={{ padding: '6px 17px' }} className="addBtn" onClick={handleSubmit}>
                                {global.edit[+localStorage.getItem('atsLang') || 1]}
                            </button>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    )
}
